module.exports = { "default": require("core-js/library/fn/reflect/get-own-property-descriptor"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/get-own-property-descriptor.js
// module id = BNqH
// module chunks = 3